export default {
  Unread: 1,
  Read: 2,
  Deleted: 3
}